import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
import InfoPill from "../InfoPill";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Confirm from "../Confirm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { usePermissions } from "../contexts/PermissionContext";
import { SessionContext } from "../SessionProvider";

const ExamList = (props) => {
  const { selectedSessionId, setSelectedSessionId, currentSessionId } =
    useContext(SessionContext);

    const [isCurrentSession,setIsCurrentSession] = useState();
    

    useEffect(() => {
      async function init() {
        try {
          if (currentSessionId !== null && currentSessionId !== undefined) {
            setIsCurrentSession(selectedSessionId === currentSessionId);
          }
        } catch (error) {
          console.log('error=>', error);
        }
      }
      init();
    }, [selectedSessionId,isCurrentSession]);

  console.log("selectedSessionId on exam=>", selectedSessionId);
  const { rolePermissions, userInfo } = usePermissions();
  const [body, setBody] = useState([]);
  const [sessionYear, setSessionYear] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [rowRecords, setRowRecords] = useState({});
  const [updateStatus, setUpdateStatus] = useState(false);
  const [isFinal, setIsFinal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [newTitle, setNewTitle] = useState({
    status: "Active",
  });

  const canCreate = rolePermissions?.Exam_List?.can_create;
  const canEdit = rolePermissions?.Exam_List?.can_edit;
  const canDelete = rolePermissions?.Exam_List?.can_delete;

  useEffect(() => {
    async function init() {
      try {
        const result = await schoolApi.fetchExamTitles();
        if (result.success) {
          const filteredRecords = result.records.filter(
            (record) => record.sessionid === selectedSessionId
          );
          setBody(filteredRecords);
        } else {
          setBody([]);
        }
      } catch (err) {
        setBody([]);
      }
    }
    init();
  }, [reload, selectedSessionId]);

  useEffect(() => {
    async function getSessions() {
      try {
        const sessions = await schoolApi.fetchSessions();
        if (sessions.success) {
          setSessionYear(sessions.result);
        } else {
          setSessionYear([]);
        }
      } catch (err) {
        toast.error("An error occurred while fetching sessions.");
        setSessionYear([]);
      }
    }
    getSessions();
  }, [showModal]);

  const header = [
    {
      title: "Exam Title",
      prop: "name",
      isFilterable: true,
      show: true,
      //  cell: (row) => <div style={{ textAlign: "center" }}>{row.name}</div>,
    },
    {
      title: "Final Result",
      prop: "isfinal",
      isFilterable: true,
      show: true,
      cell: (row) => (
        // <div style={{ textAlign: "center" }}>
        <Form.Check
          type="checkbox"
          disabled
          checked={row.isfinal ? row.isfinal : false}
        />
        // </div>
      ),
    },
    {
      title: "Status",
      prop: "status",
      isFilterable: true,
      show: true,
      cell: (row) => (
        //  <div style={{ textAlign: "center" }}>
        <Button
          className="btn-sm mx-2"
          style={{ width: "80px" }}
          variant={row.status === "Active" ? "success" : "danger"}
          disabled={isCurrentSession === false?true:false}
          onClick={() => toggleStatus(row)}
        >
          {row.status}
        </Button>
        // </div>
      ),
    },
    {
      title: "Session",
      prop: "session",
      isFilterable: true,
      show: true,
      //  cell: (row) => <div style={{ textAlign: "center" }}>{row.session}</div>,
    },
    {
      title: "Action",
      prop: "",
      isFilterable: true,
      show: true,
      cell: (row) => (
        <div>
          {(userInfo?.userrole === "SYS_ADMIN" ||
            userInfo?.userrole === "ADMIN" ||
            canEdit) && (
            <Button
              className="btn btn-sm edit-button mx-2"
              onClick={() => handleEditButton(row)}
              disabled={isCurrentSession === false?true:false}
            >
              <i className="fa-regular fa-pen-to-square"></i>
            </Button>
          )}
          {(userInfo?.userrole === "SYS_ADMIN" ||
            userInfo?.userrole === "ADMIN" ||
            canDelete) && (
            <button
              className="btn btn-sm btn-danger mx-2"
              onClick={() => handleDeleteButton(row)}
              disabled={isCurrentSession === false?true:false}
            >
              <i className="fa fa-trash"></i>
            </button>
          )}
        </div>
      ),
    },
  ];

  // const visibleHeader = header.filter((col) => col.show);

  const handleMethod = () => {
    setShowModal(true);
    setIsDisabled(false);
    console.log("sessionYear@@=>", sessionYear);
    const currentSession = sessionYear?.find((sess) => {
      return sess.id === selectedSessionId;
    });

    console.log("currentSession@=>", currentSession);

    if (currentSession) {
      setNewTitle({
        ...newTitle,
        sessionid: currentSession.id,
        session: currentSession.year || "",
        status: "Active",
      });
    }
  };
  const toggleStatus = (row) => {
    if (
      canEdit ||
      userInfo?.userrole === "SYS_ADMIN" ||
      userInfo?.userrole === "ADMIN"
    ) {
      setUpdateStatus(true);
      setRowRecords(row);
    }
  };

  const handleEditButton = (row) => {
    setIsDisabled(true);
    setNewTitle(row);
    setIsEdit(true);
    setShowModal(true);
    setDeleteModal(false);
  };

  const handleDeleteButton = (row) => {
    setReload(false);
    setDeleteId(row.id);
    setDeleteModal(true);
  };
  const deleteTitle = async () => {
    try {
      const result = await schoolApi.deleteTitle(deleteId);
      if (result.success) {
        toast.success("Record deleted successfully.");
        setReload(true);
        setDeleteModal(false);
        setNewTitle({});
      }
    } catch (error) {
      return toast.error(error.response.data.message);
    }
  };

  const changeStatus = async () => {
    try {
      rowRecords.status =
        rowRecords.status === "Active" ? "Inactive" : "Active";
      const result = await schoolApi.updateExamTitle(rowRecords.id, rowRecords);
      if (result) {
        toast.success("Record updated successfully.");
        setUpdateStatus(false);
        setReload(true);
      } else {
        toast.error("Failed to update record.");
      }
    } catch (error) {
      rowRecords.status = "Active";
      toast.error(error.response.data.message);
    }
  };

  const handleChange = (e) => {
    const { name, value, selectedIndex } = e.target;
    if (e.target.name === "sessionid" && selectedSessionId) {
      toast.error("You can only select the current session!");
    } else {
      setNewTitle({
        ...newTitle,
        [name]: value,
      });
    }
  };
  const handleSaveNewTitle = async () => {
    if (!newTitle.name.trim() || !newTitle.status || !newTitle.sessionid) {
      toast.error("Missing required fields");
      return;
    }

    try {
      let result;
      if (newTitle.id) {
        result = await schoolApi.updateExamTitle(newTitle.id, { ...newTitle });
        if (result.success) {
          toast.success("Record updated successfully.");
          setBody((prev) =>
            prev.map((item) =>
              item.id === newTitle.id ? { ...newTitle } : item
            )
          );
        } else {
          return toast.error(result.message);
        }
      } else {
        result = await schoolApi.createExamTitle({ ...newTitle });

        if (result.success) {
          toast.success("Record saved successfully.");
          setBody((prev) => [...prev, { ...result.record }]); // Add the new record to the body
        } else {
          return toast.error(result.message);
        }
      }
      setReload((prev) => !prev);
      setShowModal(false);
      setNewTitle({ status: "Active" });
    } catch (error) {
      console.log("catch block");
      return toast.error(error.response.data.message);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNewTitle({});
  };

  const handleCheckboxChange = (event) => {
    setIsFinal(event.target.checked);
    setNewTitle({ ...newTitle, [event.target.name]: event.target.checked });
  };

  const labels = {
    beforeSelect: " ",
  };

  return (
    <>
      <Helmet>
        {" "}
        <title>{props?.tabName}</title>{" "}
      </Helmet>
      <Row className="g-0">
        <Col lg={2} className="mx-3">
          <Link className="nav-link mx-2" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Exam List
          </Link>
        </Col>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        {deleteModal && (
          <Confirm
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
            deleteTitle={deleteTitle}
            title="Confirm delete?"
            message="You are going to delete the record. Are you sure?"
            table="exam_title"
          />
        )}

        {updateStatus && (
          <Confirm
            show={updateStatus}
            onHide={() => setUpdateStatus(false)}
            changeStatus={changeStatus}
            title={`Confirm ${
              rowRecords?.status === "Active" ? "Inactive" : "Active"
            }?`}
            message="You are going to update the status. Are you sure?"
            table="exam_title_status_update"
          />
        )}
        <Col lg={12} className="p-lg-4">
          <DatatableWrapper
            body={body}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 15,
                options: [5, 10, 15, 20],
              },
            }}
          >
            <Row className="mb-4">
              <Col
                xs={12}
                lg={3}
                className="d-flex flex-col justify-content-end align-items-end"
              >
                <Filter />
              </Col>
              <Col
                xs={12}
                sm={5}
                lg={5}
                className="d-flex flex-col justify-content-start align-items-start"
              >
                <PaginationOptions labels={labels} />
                <div style={{ marginTop: "5px" }}>
                  <InfoPill left="Total Exams" right={body?.length} />
                </div>
              </Col>
              <Col
                xs={12}
                sm={6}
                lg={4}
                className="mb-2 d-flex flex-col justify-content-end align-items-end"
              >
                {(userInfo?.userrole === "SYS_ADMIN" ||
                  userInfo?.userrole === "ADMIN" ||
                  canCreate) && (
                  <Button
                    className="btn-light add-new-button"
                    variant=""
                    onClick={() => handleMethod()}
                    disabled={isCurrentSession === false?true:false}
                  >
                    New Exam
                  </Button>
                )}
              </Col>
            </Row>
            <Table striped className="data-table">
              <TableHeader />
              <TableBody />
            </Table>
            <Pagination />
          </DatatableWrapper>
        </Col>

        <Col lg={2}></Col>
      </Row>

      <Modal
        show={showModal}
        backdrop="static"
        centered
        aria-labelledby="contained-modal-title-vcenter"
        onHide={handleCloseModal}
      >
        <Modal.Header centered closeButton>
          <Modal.Title>New Exam</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="mt-3">
            <Row>
              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                    Title Name
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    value={newTitle.name || ""}
                    name="name"
                    placeholder="--Enter Title Name--"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mx-3">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                    Status
                  </Form.Label>
                  <Form.Select
                    required
                    name="status"
                    value={newTitle.status || ""}
                    onChange={handleChange}
                  >
                    <option value="">-- Select Status --</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col lg={6} className="mt-3">
                <Form.Group className="mx-3">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicFirstName"
                  >
                    Session
                  </Form.Label>
                  <Form.Select
                    required
                    name="sessionid"
                    value={newTitle.session}
                    onChange={handleChange}
                    disabled={isDisabled}
                  >
                    <option value="">-- Select Session --</option>
                    {sessionYear.map((session) => (
                      <option key={session.id} value={session.year}>
                        {session.year}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col lg={6} className="mt-3">
                <Form.Group className="mx-3">
                  <Form.Label
                    className="form-view-label"
                    htmlFor="formBasicIsFinal"
                  >
                    Final Result
                  </Form.Label>
                  <Form.Check
                    type="checkbox"
                    name="isfinal"
                    checked={newTitle.isfinal === true ? true : false}
                    onChange={handleCheckboxChange}
                    id="formBasicIsFinal"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveNewTitle}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ExamList;
